import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const nycLowerManhattanOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'new-york',
  neighborhoodSlug: 'lower-manhattan',
  neighborhoodDisplayName: 'Lower Manhattan',
  metroDisplayName: 'New York',
  totalCodiClientsInNeighborhood: 6,
  nycLocalPreset: 'manhattanStandard',
  whereFromStreetsToLandmark: 'from the buildings along Broadway, Maiden Ln, and Wall St to the clusters near NYSE',
  whereTeamStreets: 'Broadway, Maiden Ln, Wall St, Broad St',
  clientDescriptor: 'around 30 people fintech startup near Maiden Ln',
  counts: {
    managedCleaningOffices: 4,
    managedPantryOffices: 6,
    managedInternetOffices: 6,
    managedFurnitureOffices: 4,
    managedOfficeAssistantOffices: 4,
    managedDeepCleaningOffices: 3,
    managedCarpetCleaningOffices: 2,
    managedWindowCleaningOffices: 2,
    managedGlassCleaningOffices: 3,
    managedWasteRecyclingOffices: 3,
    managedPantryInventoryOffices: 5,
    managedCoffeeServiceOffices: 4,
    managedWaterServiceOffices: 4,
    managedTeamLunchOffices: 2,
    managedBreakfastCateringOffices: 2,
    managedIndividualMealsOffices: 1,
    managedAdHocCateringOffices: 3,
    managedHappyHourOffices: 2,
    managedConferenceRoomAvOffices: 3,
    managedNetworkInstallationOffices: 5,
    managedNetworkManagementOffices: 4,
    managedCableManagementOffices: 3,
    managedRoomBookingOffices: 2,
    managedPrintingSetupOffices: 3,
    managedInteriorDesignOffices: 3,
    managedOfficeMuralsOffices: 1,
    managedOfficePaintingOffices: 2,
    managedGlassFrostingOffices: 2,
    managedOfficeSignageOffices: 2,
    managedCareRoomOffices: 1,
    managedFurnitureAssemblyOffices: 4,
    managedLayoutChangeOffices: 2,
    managedOfficePlantsOffices: 3,
    managedKeylessAccessOffices: 4,
    managedAlarmSystemsOffices: 2,
    managedSecurityCamerasOffices: 3,
    managedKeypadOffices: 3,
    managedLockboxOffices: 1,
    managedVisitorManagementOffices: 2,
    managedBusinessInsuranceOffices: 3,
    managedElectricalServicesOffices: 4,
    managedHvacOffices: 3,
    managedPlumbingOffices: 3,
    managedPestControlOffices: 3,
    managedOfficeMovingOffices: 4,
    managedMountingInstallationOffices: 5
  },
  quotes: {
    cleaning: 'Seamless move-in experience \u2014 Codi set up cleaning from day one.',
    pantryRestocking: "Manhattan delivery windows are brutal. Codi figures it out so we don't have to.",
    internet: 'COI requirements for riser access are a headache. Codi just handles it.',
    officeAssistant: "Codi's on-site person handles packages, visitors, and vendor access \u2014 all of it.",
    officeFurniture: 'Elevator booking for furniture deliveries is a whole thing in NYC. Codi handled it.',
    deepCleaning: 'Financial District buildings have strict after-hours access rules. Codi navigated all of it.',
    carpetCleaning: 'Older Lower Manhattan building, carpets need more frequent professional care. Codi manages it.',
    windowCleaning: 'Views of the harbor from our office windows. Codi keeps them clear year-round.',
    glassConferenceRoom: 'Client-facing conference rooms need to look sharp at all times. Codi ensures that.',
    wasteRecycling: 'Waste compliance in FiDi buildings is complex. Codi handles it on a scheduled basis.',
    pantryInventory: 'FiDi fintech office \u2014 pantry management is not where we spend our time. Codi automates it.',
    coffeeService:
      'Trading hours start early. Codi makes sure the coffee is always ready and the machine is maintained.',
    waterService: 'Filtered water in a Lower Manhattan office. Codi handles the setup and scheduled restocking.',
    teamLunch:
      'Weekly team lunch in the Financial District. Codi coordinates caterers and manages building delivery access.',
    breakfastCatering: 'Early morning client meetings need breakfast. Codi handles it on short notice every time.',
    individualMeals:
      'Daily lunch for the FiDi team. Codi manages the vendor and delivery so nobody has to think about it.',
    adHocCatering:
      'Client and investor events in Lower Manhattan. Codi handles catering so the team can focus on the meeting.',
    happyHour: 'Friday wind-down ritual. Codi handles drinks and setup in our Lower Manhattan office.',
    conferenceRoomAv:
      'Financial District clients expect polished A/V. Codi installed a reliable system across all our meeting rooms.',
    networkInstallation:
      'FiDi building riser access requires COI. Codi handled all approvals and installed our managed network.',
    networkManagement:
      'Codi monitors our Lower Manhattan network. Fintech operations can\u2019t afford downtime \u2014 Codi prevents it.',
    cableManagement:
      'Older FiDi building with decades of cable buildup. Codi sorted it out \u2014 labeled, documented, and clean.',
    roomBooking:
      'Three conference rooms in our FiDi office. Codi deployed room tablets and handles all booking conflicts.',
    printingSetup:
      'High-security Lower Manhattan building required COI for delivery. Codi managed it and got the printers installed.',
    interiorDesign:
      'Pre-renovation FiDi space needed a full design pass. Codi managed the space plan and coordinated the build-out.',
    officeMurals:
      'Historic FiDi building, one blank wall that needed character. Codi found the right artist and handled building approval.',
    officePainting:
      'Full office repaint before a new lease cycle. Codi handled COI, after-hours scheduling, and all painting logistics.',
    glassFrosting:
      'Privacy film on the executive suite glass. Codi measured and installed without disrupting operations.',
    officeSignage:
      'FiDi office with client-facing reception needed professional signage. Codi delivered design and installation.',
    careRoom:
      'New hire needed a private care room immediately. Codi had it set up with furniture and privacy features within days.',
    furnitureAssembly:
      'Full floor furniture delivery in a secure FiDi building. Codi handled freight access, assembly, and waste removal.',
    layoutChange:
      'Financial team restack across two floors. Codi managed furniture moves and cable rerouting over one weekend.',
    officePlants:
      'FiDi office with limited daylight. Codi selected low-light plants that thrive and maintains them on a schedule.',
    keylessAccess:
      'Lower Manhattan building security required keyless access registration. Codi managed the full process including COI and vendor coordination.',
    alarmSystems:
      'FiDi building required a monitored alarm before occupancy. Codi handled vendor selection, COI, and ongoing testing.',
    securityCameras:
      'Fintech office in Lower Manhattan \u2014 security cameras at all access points. Codi installed and manages the full system.',
    keypads: 'Multiple entry points in our FiDi office. Codi installed keypads and manages codes for the whole team.',
    lockboxes:
      'After-hours access is frequent in FiDi buildings. Codi manages our lockbox with building security compliance.',
    visitorManagement:
      'Client and investor visits are constant in Lower Manhattan. Codi deployed a visitor management system with badge printing.',
    businessInsurance:
      'FiDi building requires frequent COI updates. Codi manages our business insurance and handles all certificate distribution.',
    electricalServices:
      'Older FiDi building required electrical upgrades for modern office density. Codi managed DOB permits, licensed electricians, and building coordination.',
    hvac: 'HVAC in a historic Lower Manhattan building is complex. Codi manages a specialist vendor and coordinates with building engineering for all service calls.',
    plumbing:
      'High-security FiDi building requires licensed plumbers with proper COI. Codi manages vendor vetting, scheduling, and building notification for all plumbing work.',
    pestControl:
      'FiDi building compliance requires documented quarterly pest control. Codi schedules treatments and maintains compliance records.',
    officeMoving:
      'Fintech office move with sensitive equipment and strict building access rules. Codi managed mover COI, freight elevator booking, and the full setup.',
    mountingInstallation:
      'Client-facing conference rooms needed professional TV mounts and whiteboard installation. Codi completed all mounting with hidden cable management.'
  },
  officeAssistant: {}
});
